import { makeStyles } from '@material-ui/core/styles';
import fonts from 'src/constants/fonts';
import mediaQueries from 'src/constants/mediaQueries';
import spacing from 'src/constants/spacing';
import arrowNext from '../assets/arrow-right.png';
import arrowNextCur from '../assets/arrow-right.cur';
import arrowPrevious from '../assets/arrow-left.png';
import arrowPreviousCur from '../assets/arrow-left.cur';

export default makeStyles(
  () => ({
    root: {
      position: 'relative',
      [mediaQueries.Mobile]: {
        padding: `0 ${spacing.Gutter.Desktop / 2}px`,
      },
      [mediaQueries.AfterMobile]: {
        height: '100%',
      },
    },
    mobileWrapper: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      [mediaQueries.Tablet]: {
        padding: `0 ${spacing.Gutter.Tablet}px`,
      },
    },
    // Same click zones and arrow cursors the diaporama uses to step through
    // project images, here stepping through the entries of an overview.
    entryBtn: {
      position: 'absolute',
      top: 120,
      bottom: 120,
      width: '25%',
      zIndex: 2,
    },
    entryPrevious: {
      left: 0,
      '&': {
        cursor: `url(${arrowPrevious}),e-resize`,
      },
      cursor: `url(${arrowPreviousCur}) 19 28 ,e-resize`,
    },
    entryNext: {
      right: 0,
      '&': {
        cursor: `url(${arrowNext}),e-resize`,
      },
      cursor: `url(${arrowNextCur}) 19 28 ,e-resize`,
    },
    figure: {
      position: 'relative',
      marginBottom: spacing.Gutter.Mobile / 2,

      '&:first-child': {
        order: 0,
      },
      '&:nth-child(n+2)': {
        order: 2,
      },

      // Mobile/tablet counterpart of the Diaporama portrait mask.
      '[data-orientation="portrait"] & img': {
        width: '100%',
        aspectRatio: '3 / 4',
        objectFit: 'cover',
        objectPosition: 'center top',
      },
    },
    img: {
      width: '100%',
      maxHeight: '100%',
    },
    content: {
      lineHeight: '1.3',
      textAlign: 'justify',
      hyphens: 'auto',

      [mediaQueries.Mobile]: {
        order: 1,
        marginBottom: spacing.Gutter.Mobile,
      },

      [mediaQueries.AfterMobile]: {
        height: 'auto',
      },

      [mediaQueries.BigDesktop]: {},
    },
    title: {
      ...fonts.DTNobelCondBold,
      display: 'none',
      [mediaQueries.AfterMobile]: {
        display: 'initial',
      },
    },
    // Only rendered when the entry carries a role or e-mail (team members).
    // Left aligned with the image: nothing else on this page is centred.
    caption: {
      marginTop: 8,
      lineHeight: 1.35,
    },
    captionName: {
      ...fonts.DTNobelCondBold,
      textTransform: 'uppercase',
      marginRight: '0.5em',
    },
    captionRole: {
      ...fonts.DTNobelCondBold,
    },
    captionEmail: {
      display: 'block',
      wordBreak: 'break-word',
      // A mailto: link, styled as the plain text it replaced.
      color: 'inherit',
      textDecoration: 'none',
    },
    text: {
      paddingRight: 5,

      [mediaQueries.Mobile]: {
        paddingTop: 10,
      },
    },
    pdfLink: {
      display: 'block',
      paddingTop: 5,
      ...fonts.DTNobelCondBold,

      [mediaQueries.BigDesktop]: {
        fontSize: '1.1rem',
      },
    },
    diaporamaContainerDesktop: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      maxHeight: 'calc(100vh - var(--headerHeight))',
      width: 'fit-content',
      '--headerHeight': `${spacing.HeaderHeight.Desktop}px`,
      [mediaQueries.Desktop]: {
        '--headerHeight': `${spacing.HeaderHeight.Desktop}px`,
      },
      [mediaQueries.BigDesktop]: {
        '--headerHeight': `${spacing.HeaderHeight.BigDesktop}px`,
      },
      [mediaQueries.Mobile]: {
        padding: `0 ${spacing.Gutter.Mobile}px`,
      },
      [mediaQueries.Tablet]: {
        padding: `0 ${spacing.Gutter.Tablet}px`,
      },
      [mediaQueries.Laptop]: {
        padding: `0 ${spacing.Gutter.Laptop}px`,
      },
      [mediaQueries.Desktop]: {
        padding: `0 ${spacing.Gutter.Desktop}px`,
      },
      [mediaQueries.BigDesktop]: {
        padding: `0 ${spacing.Gutter.BigDesktop}px`,
      },
    },
    mainTextContainer: {
      textAlign: 'center',
      position: 'relative',
    },
    mainText: {
      marginTop: '2rem',
      lineHeight: '1.3',
      hyphens: 'auto',
      width: '100%',
      fontSize: '1.5rem',
      fontFamily: 'DTNobelLight, Times New Roman',
      textAlign: 'left',
      [mediaQueries.Mobile]: {
        padding: `0 ${spacing.Gutter.Mobile}px`,
      },
      [mediaQueries.Tablet]: {
        padding: `0 ${spacing.Gutter.Tablet}px`,
      },
      [mediaQueries.Laptop]: {
        padding: `0 ${spacing.Gutter.Laptop}px`,
      },
      [mediaQueries.Desktop]: {
        padding: `0 ${spacing.Gutter.Desktop}px`,
      },
      [mediaQueries.BigDesktop]: {
        padding: `0 ${spacing.Gutter.BigDesktop}px`,
        fontSize: '1.8rem',
      },
      [mediaQueries.AfterTablet]: {
        opacity: 0,
        transition: 'opacity 300ms',
        '&[data-showText="true"]': {
          opacity: 1,
        },
      },
    },
    downButtonContainer: {
      display: 'none',
      [mediaQueries.AfterTablet]: {
        display: 'block',
      },
      position: 'absolute',
      top: '-2rem',
      left: 0,
      right: 0,
      textAlign: 'center',
      flexShrink: 0,
      transition: 'opacity 300ms',
      zIndex: 1,
      '&[data-hidden="true"]': {
        opacity: 0,
        pointerEvents: 'none',
      },
    },
    downButton: {
      margin: '0 auto',
      padding: '1rem 2rem',
      ...fonts.DTNobelCondBold,
      fontSize: '0.87rem',
      textTransform: 'uppercase',
      display: 'inline-flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 6,
    },
    upButtonContainer: {
      marginTop: '1rem',
      textAlign: 'center',
    },
    upButton: {
      margin: '0 auto',
      padding: '1rem 2rem',
    },
  }),
  { name: 'DetailPage' }
);
